// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"4a796802","553":"351042fa","678":"8df7c38b"}[chunkId] + ".chunk.css";
};